export const loadParamsBasedOnKeys = (
  params: URLSearchParams,
  keys: string[],
) =>
  Object.fromEntries(
    Array.from(params)
      .filter(([key]) => keys.includes(key))
      .map(([key]) => {
        const values = params.getAll(key);
        return [key, values.length > 1 ? values.join(',') : values[0]];
      }),
  );
